import o,{keyframes as t}from"styled-components";import{theme as r}from"../../../theme.js";const s=t`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`,i=t`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`,e=a=>{switch(a){case"top":return t`
        0% {
          transform: translateY(-100px);
        }
        100% {
          transform: translateY(0px);
        }
      `;case"bottom":return t`
        0% {
          transform: translateY(100px);
        }
        100% {
          transform: translateY(0px);
        }
      `;case"left":return t`
        0% {
          transform: translateX(-100px);
        }
        100% {
          transform: translateX(0px);
        }
      `;case"right":return t`
        0% {
          transform: translateX(100px);
        }
        100% {
          transform: translateX(0px);
        }
      `}},n=a=>{switch(a){case"top":return t`
        0% {
          transform: translateY(0px);
        }
        100% {
          transform: translateY(-100px);
        }
      `;case"bottom":return t`
        0% {
          transform: translateY(0px);
        }
        100% {
          transform: translateY(100px);
        }
      `;case"left":return t`
        0% {
          transform: translateX(0px);
        }
        100% {
          transform: translateX(-100px);
        }
      `;case"right":return t`
        0% {
          transform: translateX(0px);
        }
        100% {
          transform: translateX(100px);
        }
      `}},p=o.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  top: 0;
  left: 0;
  padding-bottom: env(safe-area-inset-bottom);
  padding-top: env(safe-area-inset-top);
  height: 100%;
`,l=o.div`
  background-color: ${r.colors.shades[0]};
  position: absolute;
  overflow-y: auto;
  &.top, &.bottom {
    width: 100%;
    max-height: 80%;
  }
  &.left, &.right {
    height: 100%;
  }
  &.top {
    top: 0;
    left: 0;
    border-radius: 0 0 6px 6px;
  }
  &.right {
    top: 0;
    right: 0;
    border-radius: 6px 0 0 6px;
  }
  &.bottom {
    bottom: 0;
    left: 0;
    border-radius: 6px 6px 0 0;
  }
  &.left {
    top: 0;
    left: 0;
    border-radius: 0 6px 6px 0;
  }
  &.show {
    animation: ${s} .15s linear both, ${({position:a})=>e(a)} .3s linear both;
  }
  &.hide {
    animation: ${i} .1s linear .1s both, ${({position:a})=>n(a)} .3s linear both;
  }
`,d=o.div`
  width: 100%;
  height: 100%;
  background-color: #33333399;
`,c=o.div`
  padding: ${r.spacing*4}px;
`;o.button`
  font-size: 16px;
  color: ${r.colors.gray[800]};
  border: none;
  padding: 0;
  background-color: unset;
  display: block;
  padding: ${r.spacing*3}px;
  border-radius: ${r.radius}px;
  width: 100%;
  text-align: left;
  &.with-icon {
    display: grid;
    grid-template-columns: 24px 1fr;
    grid-column-gap: ${r.spacing*2}px;
    align-items: center;
    > svg {
      width: 20px;
      height: 20px;
      > g, path {
        fill: ${r.colors.gray[800]};
      }
    }
  }
  &:hover {
    background-color: ${r.colors.gray[100]};   
  }
`;export{d as BlurWrapper,p as Container,l as Content,c as DrawerContainer,e as slideIn,n as slideOut};
